export const MRO_CART_TESTIDS = {
    CONTAINER: "mro-rx-cart-container-{0}",
};

export const MRO_CART_DELIVERY_SPEED_TEST_IDS = {
    CART_DELIVERY_SPEED: "test-mro-cart-delivery-speed",
    CONTAINER: "test-mro-delivery-speed-container",
    HALF_CARD: "test-mro-delivery-speed-half-card",
    CONFIRM: "test-mro-delivery-speed-confirm",
};
